import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material'
import PropTypes from 'prop-types'

import { ColorBoxContent } from '../../../common/ui/colorBox'

/**
 * Add a user within a new customer entry
 * @returns {React.ReactElement}
 */
export default function AddUser({
  isAddUserModalOpen,
  setIsAddUserModalOpen,
  roleOptions,
  handleAddUser,
  formik
}) {
  return (
    <>
      <Dialog
        open={isAddUserModalOpen}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Box
          sx={{
            width: '600px',
            height: '600px',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <DialogContent sx={{ p: '48px' }}>
            <Typography variant='h3'>Add User</Typography>
            <ColorBoxContent
              variant='secondary'
              style={{
                marginTop: '36px',
                border: '1px solid #B8C4D3',
                width: '80%',
                margin: '30px auto'
              }}
            >
              <Box sx={{ marginBottom: '24px' }}>
                <FormLabel>Name</FormLabel>
                <TextField
                  autoFocus
                  id='contactName'
                  variant='standard'
                  name='contactName'
                  value={formik.values.contactName}
                  onChange={(e) => {
                    formik.handleBlur(e)
                    formik.handleChange(e)
                  }}
                  sx={{ marginTop: '4px', width: '95%' }}
                  error={
                    formik.touched.contactName &&
                    Boolean(formik.errors.contactName)
                  }
                  helperText={
                    formik.touched.contactName && formik.errors.contactName
                  }
                  data-cy='newUserName'
                />
              </Box>
              <Box sx={{ marginBottom: '24px' }}>
                <FormLabel>Email</FormLabel>
                <TextField
                  id='email'
                  variant='standard'
                  name='email'
                  value={formik.values.email}
                  onChange={(e) => {
                    formik.handleBlur(e)
                    formik.handleChange(e)
                  }}
                  sx={{ marginTop: '0px', width: '95%' }}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                  data-cy='newUserEmail'
                />
              </Box>
              <Box sx={{ marginBottom: '24px' }}>
                <FormLabel>Contact</FormLabel>
                <TextField
                  id='contactNumber'
                  variant='standard'
                  name='contactNumber'
                  value={formik.values.contactNumber}
                  onChange={(e) => {
                    formik.handleBlur(e)
                    formik.handleChange(e)
                  }}
                  sx={{ marginTop: '0px', width: '95%' }}
                  error={
                    formik.touched.contactNumber &&
                    Boolean(formik.errors.contactNumber)
                  }
                  helperText={
                    formik.touched.contactNumber && formik.errors.contactNumber
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position='start'>+65</InputAdornment>
                    )
                  }}
                  data-cy='newUserNumber'
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '24px'
                }}
              >
                <FormLabel>Role</FormLabel>
                <Select
                  variant='standard'
                  id='role'
                  name='role'
                  sx={{ minWidth: '100px' }}
                  value={formik.values.role}
                  onChange={(e) => {
                    formik.handleBlur(e)
                    formik.handleChange(e)
                  }}
                  data-cy='newUserRole'
                >
                  {roleOptions.map((role) => {
                    return (
                      <MenuItem
                        key={role}
                        value={role}
                        data-cy={`menu-${role}`}
                      >
                        {role}
                      </MenuItem>
                    )
                  })}
                </Select>
              </Box>
            </ColorBoxContent>
          </DialogContent>

          <DialogActions>
            <Button
              variant='secondary'
              sx={{
                display: 'flex',
                height: '50px'
              }}
              onClick={() => setIsAddUserModalOpen(false)}
              data-cy='newUserCloseBtn'
            >
              Close
            </Button>
            <Button
              variant='filled'
              sx={{
                display: 'flex',
                height: '50px'
              }}
              style={{ height: '50px' }}
              onClick={() => handleAddUser()}
              disabled={
                !formik.values.contactName ||
                !formik.values.email ||
                !formik.values.contactNumber ||
                !formik.values.role
              }
              data-cy='newUserSubmitBtn'
            >
              Submit
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}

AddUser.propTypes = {
  isAddUserModalOpen: PropTypes.bool,
  setIsAddUserModalOpen: PropTypes.func,
  handleAddUser: PropTypes.func,
  roleOptions: PropTypes.array,
  formik: PropTypes.obj
}
